import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import BookingStatusBadge from './BookingStatusBadge';
import { Checkbox } from '../../../components/ui/Checkbox';
import { needsPriceFinalization } from '../../../utils/pricingUtils';

const BookingMobileCard = ({ 
  booking, 
  isSelected, 
  onSelect, 
  canSelect = true,
  onViewDetails, 
  onContact 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const pricePrefix = needsPriceFinalization(booking) ? 'From ' : '';

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  const formatTime = (timeString) => {
    const [hours, minutes] = timeString?.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 mb-4">
      <div className="flex items-start gap-3">
        {canSelect && (
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelect(booking?.id, e?.target?.checked)}
            className="mt-1"
          />
        )}
        
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="flex-1 min-w-0">
              <h3 className="font-caption font-semibold text-foreground text-base mb-1">
                {booking?.clientName}
              </h3>
              <p className="text-sm text-muted-foreground font-caption">
                {booking?.serviceName}
              </p>
            </div>
            <BookingStatusBadge status={booking?.status} />
          </div>

          <div className="flex items-center gap-4 text-sm text-muted-foreground font-caption mb-3">
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={16} />
              <span className="whitespace-nowrap">{formatDate(booking?.date)}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Clock" size={16} />
              <span className="whitespace-nowrap">{formatTime(booking?.time)}</span>
            </div>
            {booking?.price != null && (
              <span className="ml-auto font-semibold text-foreground whitespace-nowrap">
                {pricePrefix}GH¢{Number(booking.price).toFixed(2)}
              </span>
            )}
          </div>

          {isExpanded && (
            <div className="space-y-2 mb-3 pt-3 border-t border-border">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Mail" size={16} color="var(--color-muted-foreground)" />
                <span className="text-foreground font-caption">{booking?.clientEmail}</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Phone" size={16} color="var(--color-muted-foreground)" />
                <span className="text-foreground font-caption">{booking?.clientPhone}</span>
              </div>
              {booking?.notes && (
                <div className="flex items-start gap-2 text-sm">
                  <Icon name="FileText" size={16} color="var(--color-muted-foreground)" className="mt-0.5" />
                  <span className="text-muted-foreground font-caption">{booking?.notes}</span>
                </div>
              )}
            </div>
          )}

          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex-1"
            >
              {isExpanded ? 'Less' : 'More'}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="Eye"
              onClick={() => onViewDetails(booking)}
            >
              View
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="Phone"
              onClick={() => onContact(booking)}
            >
              Call
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingMobileCard;
